const getWindowWidth = state => state.windowWidth;
const getSidebarStatus = state => state.sidebarStatus;

export default {
  getWindowWidth,
  getSidebarStatus
};
